<template>
  <div class="padding-five-lr" style="background: #f8f8f8">
    <section>
      <b-container>
        <b-row>
          <b-col cols="12" class="padding-ten-tb float-left padding-left-none">
            <h5 class="title__name text-xl">Reportes Proyectos</h5>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="bg-white padding-five-all">
      <b-container>
        <b-row>
          <b-col cols="12" class="center-cl">
            <b-form @submit="generateReport">            
              <b-row>     
                <b-col lg="4" class="my-1">
                  <label class="text-grey">Fecha inicio</label>
                  <b-form-input type="date" v-model="startDate"></b-form-input>
                </b-col>
                <b-col lg="4" class="my-1">
                  <label class="text-grey">Fecha fin</label>
                  <b-form-input type="date" v-model="endDate"></b-form-input>
                </b-col>
              </b-row>
             <b-row>
            <!-- <b-col lg="4" class="my-1">
                  <b-form-group label="Email" label-for="input-email">
                    <b-form-input
                      
                      id="input-email"
                      type="email"
                      v-model.trim="valueParams.email"
                      size="md"
                      class="placeholder-black"
                      placeholder="Ingresa tu correo"
                    ></b-form-input>
                  </b-form-group>
                </b-col> -->
             </b-row> 
              <b-row>
                <b-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                  class="text-center"
                  v-show="exportarPermiso"
                >
                  <b-button class="btn-orange hidden-icon" type="submit">
                    <font-awesome-icon icon="file-excel" /> EXPORTAR
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>
<script>
//import ComboStore from "../../components/ComboStore.vue";
import axios from "axios";
import moment from "moment";
import { mapState } from "vuex";
import {getStores} from '../../assets/js/common'
import FileSaver from "file-saver";
export default {
  name: "ReportesProyectos",
  components: {   },
  data() {
    return {
      status:false,
      selectedProviderUser: "",
      formData: { names: "" },
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      valueParams: {  email: "" },
      selectedProvider: null,
      optionsProvider: [],
     // username: "username",
      selectedFilterDate: "a",
      optionStoresReport:[]
    };
  },
  computed: {
    ...mapState("module", ["perfil", "idProvider", "store", "options","username"]),
    isProfileProvider() {
      let up = this.perfil.toUpperCase();
      if (up === "PROVEEDOR") return true;
      return false;
    },
    exportarPermiso() {
      let reporteTienda = this.options.some((m) => m.id == 26);
      let reporteProveedor = this.options.some((m) => m.id == 27);
      if (reporteTienda || reporteProveedor) return true;
      return false;
    },
  },
  created() {
   // this.selectedStore = this.store[0].codigo;
   // this.getProviders();
    this.getStoresCombo();
  },
  methods: {
    async getStoresCombo() {
      try {
        let data = await getStores();
        this.optionStoresReport = data;
      } catch (error) {
        console.error(error);
      }
    },
    async getProviders() {
      if (this.isProfileProvider) {
        this.selectedProvider=this.idProvider;
        let providerId=this.idProvider?this.idProvider:null;
        let userProvider=this.username?this.username:"";
        let provider={value:providerId,text:userProvider}
        this.optionsProvider[0] = provider;
      //  this.getFilteredProviders();
      } /*else {
        this.getProvidersList();
      } */
    },
    /*async getFilteredProviders() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_PROVIDER_BASE_BUSINESS +
            "/providers/" +
            this.idProvider
        );
        let arr = [];
        arr.push(response.data);

        const data = arr.map((row) => {
          return {
            value: row.id,
            text: row.user,
          };
        });
        this.optionsProvider = data;
        this.selectedProvider = this.idProvider;
      } catch (error) {
        console.log(error);
      }
    },*/
    clearParamsVal() {
      this.valueParams.dni = null;
      this.valueParams.sellerNote = "";
      this.valueParams.sequenceOS = "";
    },
    setOptionSelected(selected) {
      console.log(selected);
      if (selected.length) {
        this.selectedProvider = selected[0].id;
        this.selectedProviderUser = selected[0].user;
      }
    },
    async generateReport() {
      try {
        event.preventDefault();
        this.$store.commit("SET_LOADING", true);
        let response = await axios.post(
           process.env.VUE_APP_REPORT_VTEX_BASE+"/hp/service-system/v1/os-report/proyectos",
          {
            store: 0,
            clientId: 0,
            fecha_inicio: this.startDate,
            fecha_fin: this.endDate,
            state: "",
            email: this.valueParams.email,
            tipoReporte: -1,
            tipoFecha: 0,
           
            registerUser: this.username,
          }, // the data to post
          {
            responseType: "blob",
          }
        );
        FileSaver.saveAs(response.data, "ReporteProyectos.xlsx");
        console.log(response);
        let values = {
          variant: "success",
          msg: "Reporte generado exitosamente",
        };
        this.$store.commit("SET_ERROR_MSG", values);
      } catch (error) {
        console.log(error);
        let values = { variant: "danger", msg: error.response.data.message };
        this.$store.commit("SET_ERROR_MSG", values);
      } finally {
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_LOADING", false);
      }
    },
  },
};
</script>
<style scoped>
.color-gray {
  color: #676767;
  font-weight: bold;
}
</style>